import { Users_01 } from '@recruit-robin/robin-theme/web-icons';
import { InformationTag } from 'components/ui/molecules/index';
import { useContext } from 'react';
import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { UserContext } from 'shared/legacy/contexts/UserContext/UserContext';

export const AvailableCredits = () => {
  const { userCredits, availableCredits, currentUser } = useContext(UserContext);
  const { dictionary } = useContext(LocalizationContext);
  const isPayPerMatch = currentUser?.tenant.payment_method === 'PAY_PER_MATCH';

  if (!userCredits || availableCredits === undefined) {
    return null;
  }

  return (
    <InformationTag
      type="default"
      size="small"
      icon={<Users_01 size={16} />}
      label={dictionary.availableCredits(availableCredits, userCredits?.total, isPayPerMatch)}
    />
  );
};
